<div *ngIf="submissionComplete" class="flex flex-row justify-center items-center">
  <mat-card class="mt-8" [ngClass]="{
        'bg-gray-700': settings.theme === 'dark',
        'bg-indigo-50': settings.theme === 'light'}">
    <mat-card-content>
      <div class="flex flex-col gap-2">

        <div class="flex flex-col" *ngIf="submissionSuccessful" style="font-size: x-large">
          <span>Thank you for registering.</span>
          <span>The program administrator will be notified of your registration and process your account.</span>
          <span>You will receive notification when your account has been approved.</span>
          <div>
            <button type="button" class="m-8" mat-raised-button color="primary" routerLink="/home">Return</button>
          </div>
        </div>

        <div class="flex flex-col text-red-400" *ngIf="!submissionSuccessful" style="font-size: x-large">
          <span>Thank you for registering.</span>
          <span>The lab(s) that you have selected, failed to register.</span>
          <span>Please contact the program administrator.</span>
          <div>
            <button type="button" class="m-8" mat-raised-button color="primary" routerLink="/contact">Contact
              Us</button>
          </div>
        </div>

      </div>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="!submissionComplete" class="flex flex-col gap-2">
  <span style="font-size: larger">Add required labs to your registration</span>

  <div class="flex flex-row gap-2">

    <div class="flex flex-col gap-2" class="w-1/2 sm:w-full">
      <mat-card class="mt-8" [ngClass]="{
        'bg-gray-700': settings.theme === 'dark',
        'bg-indigo-50': settings.theme === 'light'}">
        <mat-card-title class="flex flex-col gap-2">
          <span>Select an ORELAP licensed lab</span>
        </mat-card-title>
        <mat-card-content>
          <div class="flex flex-col gap-2">
            <div class="flex flex-row">
              <mat-form-field class="w-3/10 sm:w-full">
                <input matInput (keyup)="filterTable($event.target.value)" placeholder="Filter" />
              </mat-form-field>
            </div>
            <div style="overflow-x:auto" class="m-b-0">
              <table mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8">
                <ng-container matColumnDef="orelapId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>ORELAP Id</th>
                  <td mat-cell *matCellDef="let lab">{{lab.orelapId}}</td>
                </ng-container>
                <ng-container matColumnDef="tniId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>TNI Id</th>
                  <td mat-cell *matCellDef="let lab">{{lab.tniId}}</td>
                </ng-container>
                <ng-container matColumnDef="laboratoryName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Laboratory Name</th>
                  <td mat-cell *matCellDef="let lab" class="text-indigo-A200">{{lab.laboratoryName}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectLab(row)"></tr>

              </table>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" #TablePaginator="matPaginator"
              showFirstLastButtons></mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="mt-8" [ngClass]="{
        'bg-gray-700': settings.theme === 'dark',
        'bg-indigo-50': settings.theme === 'light'}">
        <mat-card-title class="flex flex-col gap-2">
          <span>Your current labs</span>
        </mat-card-title>
        <mat-card-content>
          <div class="flex flex-col">
            <div style="overflow-x:auto" class="m-b-0">
              <table mat-table [dataSource]="selectedSource" class="mat-elevation-z8">
                <ng-container matColumnDef="laboratoryName">
                  <th mat-header-cell *matHeaderCellDef>Laboratory Name</th>
                  <td mat-cell *matCellDef="let lab">{{lab.laboratoryName}}</td>
                </ng-container>

                <ng-container matColumnDef="delete">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let lab">
                    <button mat-mini-fab (click)="removeLab(lab.laboratoryName)" color="warn" aria-label="Delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="selectedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: selectedColumns;"></tr>

              </table>
            </div>
            <div>
              <button type="button" class="m-8" mat-raised-button (click)="submitLabRegistration()"
                color="primary">Submit Registration</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

    </div>

    <mat-card class="w-1/2 sm:w-full mt-8" [ngClass]="{
        'bg-gray-700': settings.theme === 'dark',
        'bg-indigo-50': settings.theme === 'light'}">
      <form [formGroup]="labForm" (ngSubmit)="addLab()">
        <mat-card-title class="flex flex-col gap-2">
          <div class="flex flex-row gap-2 items-center justify-start">
            <span>Select and/or create your labs</span>
            <div>
              <button type="submit" class="m-8" mat-raised-button color="primary">Add
                Laboratory</button>
            </div>
            <div>
              <button type="button" class="m-8" mat-raised-button (click)="clearLab()" color="warn">Clear Lab
                Info</button>
            </div>
          </div>
        </mat-card-title>
        <mat-card-content>
          <div class="flex flex-col gap-2">

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>ORELAP Id</mat-label>
                <input matInput formControlName="orelapId">
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>Laboratory Name</mat-label>
                <input matInput formControlName="laboratoryName">
                <mat-error *ngIf="labForm.get('laboratoryName').invalid">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="flex-[1_1_25%] sm:flex-[1_1_100%]">
                <mat-label>Accreditation Type</mat-label>
                <mat-select formControlName="accreditationType">
                  <mat-option value="Primary">Primary</mat-option>
                  <mat-option value="Secondary">Secondary</mat-option>
                </mat-select>
                <mat-error *ngIf="labForm.get('accreditationType').invalid">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-row gap-2">
              <div class="flex flex-col w-1/4 sm:w-1/2">
                <mat-form-field>
                  <mat-label>Primary AA</mat-label>
                  <input matInput formControlName="primaryAa">
                </mat-form-field>
                <span class="text-red-400" *ngIf="labForm.get('primaryAa').value === null">
                  Primary AA is required
                </span>
              </div>
              <mat-form-field class="w-1/4 sm:w-1/2">
                <mat-label>Secondary AA</mat-label>
                <mat-select formControlName="secondaryAa">
                  <mat-option>-- None --</mat-option>
                  <mat-option *ngFor="let state of states" value={{state}}>{{state}}</mat-option>
                </mat-select>
              </mat-form-field>

              <div class="flex flex-row">
                <div><button type="button" class="m-8" mat-raised-button (click)="addSecondaryAa()"
                    color="primary">Add</button></div>
                <div><button type="button" class="m-8" mat-raised-button (click)="clearPrimaryAa()"
                    color="warn">Clear</button></div>
              </div>

            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>Site Address</mat-label>
                <input matInput formControlName="siteAddress">
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>Site City</mat-label>
                <input matInput formControlName="siteCity">
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/4 sm:w-1/2">
                <mat-label>Site State</mat-label>
                <mat-select formControlName="siteState">
                  <mat-option>-- None --</mat-option>
                  <mat-option *ngFor="let state of states" value={{state}}>{{state}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>Site Zipcode</mat-label>
                <input matInput formControlName="siteZipCode">
                <mat-error *ngIf="labForm.get('siteZipCode').hasError('pattern')">
                  Zipcode must be in format: 99999 or 99999-9999
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>Site Phone</mat-label>
                <input matInput formControlName="sitePhone">
                <mat-error *ngIf="labForm.get('sitePhone').hasError('pattern')">
                  Phone must be in format: 999-999-9999 x9999
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>Site Fax</mat-label>
                <input matInput formControlName="siteFax">
                <mat-error *ngIf="labForm.get('siteFax').hasError('pattern')">
                  Phone must be in format: 999-999-9999 x9999
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>Site Email</mat-label>
                <input matInput formControlName="siteEmail">
                <mat-error *ngIf="labForm.get('siteEmail').hasError('email')">
                  Not a valid email address
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/4 sm:w-1/2">
                <mat-label>Mobile</mat-label>
                <mat-select formControlName="mobile">
                  <mat-option>-- None --</mat-option>
                  <mat-option value="N">No</mat-option>
                  <mat-option value="Y">Yes</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>VIN</mat-label>
                <input matInput formControlName="vin">
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/2 sm:w-full">
                <mat-label>License Plate</mat-label>
                <input matInput formControlName="licensePlate">
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <mat-form-field class="w-1/4 sm:w-1/2">
                <mat-label>License State</mat-label>
                <mat-select formControlName="licenseState">
                  <mat-option>-- None --</mat-option>
                  <mat-option *ngFor="let state of states" value={{state}}>{{state}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-row gap-2">
              <button type="submit" class="m-8" mat-raised-button color="primary">Add Laboratory</button>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>